import React from "react";

import { EyeOffIcon, EyeOpenIcon } from "./styles";

interface ShowPasswordIconProps {
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ShowPasswordIcon = ({ showPassword, setShowPassword }: ShowPasswordIconProps) => {
  if (showPassword)
    return (
      <EyeOffIcon
        size={18}
        onClick={() => setShowPassword(false)}
        onMouseDown={(event) => event.preventDefault()}
      />
    );

  return (
    <EyeOpenIcon
      size={18}
      onClick={() => setShowPassword(true)}
      onMouseDown={(event) => event.preventDefault()}
    />
  );
};
